import { render } from "./CancelOfferAnnual.vue?vue&type=template&id=12b7fd5e&ts=true"
import script from "./CancelOfferAnnual.vue?vue&type=script&lang=ts"
export * from "./CancelOfferAnnual.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__